// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__KHN1P","contentStyles":"styles_contentStyles__juOab","title":"styles_title__2Gdtc","video":"styles_video__1ODuQ"};